import { render, staticRenderFns } from "./VergabeSystem.vue?vue&type=template&id=e507bea8&"
import script from "./VergabeSystem.vue?vue&type=script&lang=js&"
export * from "./VergabeSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports